import React from 'react';
import EmailConfirmWrapper from './EmailConfirmWrapper';
import ProspectsToApprove from './chat/canvas/dsl-components/ProspectsToApprove';
import SourcingStrategyApprovalView from './chat/canvas/dsl-components/SourcingStrategyApprovalView';
import EmailSequenceApprovalView from './EmailSequenceApprovalView';

interface ConfirmationSpecialViewProps {
  methodName: string;
  methodInput: any;
}

/**
 * Renders special views for specific confirmation methods
 */
const ConfirmationSpecialView: React.FC<ConfirmationSpecialViewProps> = ({
  methodName,
  methodInput,
}) => {
  switch (methodName) {
    case 'executeSendDraft':
      return <EmailConfirmWrapper methodInput={methodInput} />;
    case 'approvePendingProspectsForCampaign':
      return <ProspectsToApprove campaignId={methodInput.campaignId} />;
    case 'approveSourcingStrategy':
      return (
        <SourcingStrategyApprovalView
          sourcingStrategyId={methodInput.sourcingStrategyId.toString()}
        />
      );
    case 'approveEmailSequences':
      return <EmailSequenceApprovalView methodInput={methodInput} />;
    default:
      return null;
  }
};

export const hasSpecialView = (methodName: string): boolean => {
  return (
    methodName === 'executeSendDraft' ||
    methodName === 'approvePendingProspectsForCampaign' ||
    methodName === 'approveSourcingStrategy' ||
    methodName === 'approveEmailSequences'
  );
};

export const getActionTitle = (methodName: string): string => {
  switch (methodName) {
    case 'executeSendDraft':
      return 'Send Email';
    case 'approvePendingProspectsForCampaign':
      return 'Approve Prospects';
    case 'approveSourcingStrategy':
      return 'Approve Sourcing Strategy';
    case 'approveEmailSequences':
      return 'Approve Email Sequence';
    case 'executeCreateMandate':
      return 'Approve Mandate';
    case 'executeAmendMandate':
      return 'Approve Mandate Amendment';
    case 'deleteLists':
      return 'Delete Lists';
    case 'deleteCampaign':
      return 'Delete Campaign';
    case 'deleteProfiles':
      return 'Delete Profiles';
    default:
      // Convert camelCase to Title Case
      return methodName
        .replace(/([A-Z])/g, ' $1')
        .replace(/^./, (str) => str.toUpperCase())
        .trim();
  }
};

export default ConfirmationSpecialView;
